import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Typography, Avatar, Chip, Tooltip, Grid } from '@mui/material';
import { Person as PersonIcon, Stars as StarsIcon } from '@mui/icons-material';
import { IndicacaoNodeData, getCoresNivel, formatarNomeNode } from '../../../utils/indicacaoFlowUtils';

const IndicacaoRootNode: React.FC<NodeProps<IndicacaoNodeData>> = ({ data }) => {
  const cores = getCoresNivel(data.nivel);
  const nomeFormatado = formatarNomeNode(data.nome, 18);

  return (
    <Box
      sx={{
        width: 50,
        height: 20,
        background: 'white',
        border: `2px solid ${cores.border}`,
        borderRadius: '100%',
        padding: '10px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        position: 'relative',
        color: cores.text,
      }}
    >
      {/* Avatar do cliente */}
      <Box 
        sx={{ 
          display: 'flex',
          alignItems: 'center',        
          justifyContent: 'center',
          marginTop: '-75px',
          position: 'relative',
          cursor: 'pointer',
        }}
        
      >
        <img src="/nivel0.png" width={80} height={80} alt="SysUp" />
      </Box>
     
      {/* Handle de saída (para conectar com indicações) */}
      <Handle
        type="source"
        position={Position.Bottom}
        style={{
          width: 5,
          height: 5,
          border: 'none',
          background: 'transparent',
        }}
      />
    </Box>
  );
};

export default IndicacaoRootNode; 